<div class="filter-container" [@openClose]="filtersOpened && searchFilterOpened ? 'open' : 'closed'"
     (clickOutside)="exitFilters($event)">
  <div class="filter-header">
    <span>{{'CONTACTS_LIST.FILTER_BY' | translate}}</span>
    <a href="javascript:void(0)" (click)="closeFilters()"><i class="datatable-icon-close"></i></a>
  </div>
  <div class="filter-body">
    <cc-filters-tag></cc-filters-tag>
    <div class="filter-body-item p-y-0 p-r-0 pointer-clear">
      <span href="#" class="date-range-label">{{'CONTACTS_LIST.LAST_24_HOURS' | translate}}</span>
      <ui-switch
        defaultBgColor="#DBDDE7"
        color="#366BF3"
        class="date-switch custom"
        (change)="changeLastDayLog($event)"
        [(ngModel)]="lastDayPicker"
        size="small"></ui-switch>
    </div>
    <div class="date-range-wrapper filter-body-item  m-b-lg pointer-clear" [class.chosen]="!lastDayPicker">
      <div class="date-tag-info">{{dateTagView}}</div>
      <i #searchIconCalendar class="fas fa-calendar-alt" (click)="openPicker()"></i>
    </div>
    <div class="filter-body-item p-y-0 m-b-lg p-r-0 pointer-clear">
      <span href="javascript:void(0)"
            class="voicemail-recordings-label">{{'CONTACTS_LIST.VOICEMAIL_RECORDINGS' | translate}}</span>
      <ui-switch
        defaultBgColor="#DBDDE7"
        color="#366BF3"
        class="voicemail-recordings-switch custom"
        (change)="filterVoiceMailRecordings($event)"
        [(ngModel)]="isVoiceMailRecordingsFiltered"
        size="small"></ui-switch>
    </div>
    <div class="filter-body-item" (click)="editFilter('callerIds')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.MY_PHONE_NUMBER' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('callerIds')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
    <div class="filter-body-item" (click)="editFilter('clientPhoneNumbers')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.PHONE_NUMBER' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('clientPhoneNumbers')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
    <div class="filter-body-item" (click)="editFilter('users')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.USER' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('users')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
    <div class="filter-body-item" (click)="editFilter('eventTypes')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.EVENT_TYPE' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('eventTypes')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
    <div class="filter-body-item" (click)="editFilter('callLengths')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.CALL_LENGTH' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('callLengths')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
    <div class="filter-body-item" (click)="editFilter('tags')">
      <span class="filter-body-item-label">{{'CONTACTS_LIST.TAGS' | translate}}</span>
      <i class="material-icons check-circle-icon" *ngIf="isFilterEdited('tags')">check_circle</i>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
  </div>

  <div class="filter-footer">
    <button class="accept-button" (click)="setNewFilters()"
            [disabled]="!(dataRangeHasChanged || tagsWasChosen || voiceMailRecordingsHasChanged) && !basicFiltersDone">
      <a href="#">
        <i class="material-icons">search</i>
        {{'CONTACTS_LIST.APPLY_FILTERS' | translate}}
      </a>
    </button>
  </div>
</div>



